export function FlyingObjectsManager(viewManager, data) {
	this.pollTimer = null;
	this.$rest = null;
	this.viewManager = viewManager;
	this.data = data;

	this.startPolling = ($rest) => {
		this.$rest = $rest;
		this.pollTimer = setInterval(async () => {
			const resp = await this.$rest.getFlyingObjects(data);
			if(!resp) return;

			this.viewManager.flyingObjectManager.updateLocationOfFlyingObjects(resp);
		}, 3000);
	}

	this.stopPolling = () => {
		if(this.pollTimer)
			clearInterval(this.pollTimer);
	}
}
